<template>
  <v-card v-if="model && model.id" width="100%" tile elevation="0">
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>General</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card width="auto" outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <label class="font-weight-bold subtitle-1 text--primary">Equipo: </label>
                <p class="font-weight-bold text--secondary">{{ model.nombre }}</p>
              </v-col>
              <v-col cols="6" class="text-right">
                    <v-btn
                      v-if="ValidateOnlyPermiss('view.all.credentials')"
                      color="indigo darken-1"
                      @click="mostrarDocComple(model)"
                      class="my-custom-btn"
                    >
                      Credenciales
                    </v-btn>
                  </v-col>
              <v-col cols="12" sm="12" md="12" class="scroll-box">
                <label class="font-weight-bold subtitle-1 text--primary">Lista De Jugadores: </label>
                <v-simple-table fixed-header dense>
                  <thead>
                    <tr>
                      <th class="text-center"></th>
                      <th class="text-center">Nombres</th>
                      <th class="text-center">Apellidos</th>
                      <!-- <th class="text-center">Posicion</th> -->
                      <th class="text-center">Asistencia</th>
                      <th class="text-center">Goles</th>
                      <th class="text-center">Tar. Amarillas</th>
                      <th class="text-center">Tar. Rojas</th>
                      <th class="text-center">Rol</th>
                      <th class="text-center">Documentos Validados</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, index) in model.descripcion.jugadores" :key="p.id">
                      <td class="text-center">{{ index + 1 }}</td>
                      <td class="player-cell">{{ p.nombres }}</td>
                      <td class="player-cell">{{ p.apellidos }}</td>
                      <td class="text-center player-cell">{{ p.estadisticas?.asistencias }}</td>
                      <td class="text-center player-cell">{{ p.estadisticas?.goles }}</td>
                      <td class="text-center player-cell">{{ p.estadisticas?.amarillas }}</td>
                      <td class="text-center player-cell">{{ p.estadisticas?.rojas }}</td>
                      <td class="text-center player-cell">{{ p.tipo_personal_nombre }}</td>
                      <td class="text-center player-cell">{{ p.documentos_validados + '/3'}}</td>
                      <td class="text-center player-cell">
                        <v-menu bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn dark v-bind="attrs" v-on="on" color="indigo darken-1">
                              <v-icon>mdi-cog</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-if="ValidateOnlyPermiss('update.document')" @click="newData(p)">
                              <v-list-item-title>Documentación</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="ValidateOnlyPermiss('view.credencial')" @click="mostrarDoc(p)">
                              <v-list-item-title>Credencial</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="ValidateOnlyPermiss('invalite.document.player')" @click="InvalideDocument(p)">
                              <v-list-item-title>Invalidar Documentos</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="ValidateOnlyPermiss('jugadores.rol')" @click="rolJug(p)">
                              <v-list-item-title>Rol</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="ValidateOnlyPermiss('delete.player.list')" @click="deleteData(p)">
                              <v-list-item-title>Eliminar</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="showPDFModal" max-width="70%">
      <v-card>
        <v-card-title class="headline">Documento PDF</v-card-title>
        <v-card-text>
          <!-- Mostrar el PDF en un iframe -->
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="430px"></iframe>
          <p v-else>No se pudo cargar el PDF.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="showPDFModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import axios from 'axios'

export default {
  props: ['model', 'onSuccess'],
  name: 'EquipoDetails',
  mixins: [Permission],
  data: () => ({
    pdfUrl: null,
    showPDFModal: false,
    userPermissions: [],
    tab: 0,
    itemInsumos: {},
    familia: null,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: true
  }),
  components: {},
  methods: {
    ...mapActions(['urlGetServiceActionTwo', 'getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN']),
    sendEvent (item) {
      this.onSuccess(item)
    },
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    ValidateOnlyPermiss (permiso) {
      const permisos = JSON.parse(localStorage.getItem('permisos')) || []
      return this.ReadOnlyPermiso(permisos, permiso)
    },
    newData (item) {
      console.log('item:', item)
      this.SHOW_DIALOG_MAIN({
        type: 'charge',
        form: 'process',
        with: '50%',
        title: 'Documentacion',
        body: {
          objectMain: { num: 1, item, slug: 'int' },
          paramsDialog: {
            url: this.get_urls['documentos.execute'],
            urloption: this.get_urls['documentos.options'],
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    // viewCredential (item) {
    //   // Ruta local o URL de un PDF
    //   this.pdfUrl = '/ejemplo.pdf'
    //   // Mostrar el modal
    //   this.showPDFModal = true
    // },
    mostrarDoc: function (item) {
      console.log('item', item)
      this.progressbar = true
      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const formData = new FormData()
      const integrantes = [
        {
          id: item.id,
          rol: item.tipo_personal_nombre || 'Sin rol'
        }
      ]
      console.log('integrantes', integrantes)
      const equipoData = {
        equipo_id: item.equipo_id,
        nombre: item.nombre,
        padre_id: item.padre_id,
        tipo: item.tipo_personal_nombre,
        integrantes: integrantes
      }
      formData.append('documento', JSON.stringify(this.documento))
      formData.append('model', JSON.stringify(equipoData))

      axios.post('/empresa/documentos/credencial', formData, { headers: header })
        .then((response) => {
          console.log('Respuesta de la API:', response.data)

          let blob = null
          const fileType = response.data.type

          if (fileType.startsWith('image/')) {
            // Procesar imagen
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: fileType })
          } else if (fileType === 'application/pdf') {
            // Procesar PDF
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: 'application/pdf' })
          } else {
            console.error('El archivo recibido no es una imagen ni un PDF.')
            this.progressbar = false
            return
          }

          this.pdfUrl = URL.createObjectURL(blob)
          console.log('URL del archivo generado:', this.pdfUrl)

          this.progressbar = false
          this.showPDFModal = true
        })
        .catch((error) => {
          console.error('Error al mostrar documento:', error)
          this.progressbar = false
        })
    },
    mostrarDocComple: function (model) {
      console.log('model', model)
      this.progressbar = true
      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const formData = new FormData()
      const integrantes = model.descripcion.integrantes.map((id, index) => {
        return {
          id: id,
          rol: model.descripcion.roles[index] || 'Sin rol'
        }
      })
      console.log('integrantes', integrantes)
      const equipoData = {
        equipo_id: model.id,
        nombre: model.nombre,
        padre_id: model.padre_id,
        integrantes: integrantes
      }
      console.log('equipoData', equipoData)
      formData.append('documento', JSON.stringify(this.documento))
      formData.append('model', JSON.stringify(equipoData))
      axios.post('/empresa/documentos/credencial', formData, { headers: header })
        .then((response) => {
          console.log('Respuesta de la API:', response.data)

          let blob = null
          const fileType = response.data.type

          if (fileType.startsWith('image/')) {
            // Procesar imagen
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: fileType })
          } else if (fileType === 'application/pdf') {
            // Procesar PDF
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: 'application/pdf' })
          } else {
            console.error('El archivo recibido no es una imagen ni un PDF.')
            this.progressbar = false
            return
          }

          this.pdfUrl = URL.createObjectURL(blob)
          console.log('URL del archivo generado:', this.pdfUrl)

          this.progressbar = false
          this.showPDFModal = true
        })
        .catch((error) => {
          console.error('Error al mostrar documento:', error)
          this.progressbar = false
        })
    },
    InvalideDocument (item) {
      console.log('item', item)
      const data = { jugadorId: item.id }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '35%',
        title: `Invalidar Documentos de ${item.nombres}`,
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_InvalideForm,
            url: this.get_urls['empresa.documentos.validatejug'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData (jugadorId) {
      console.log('jugador:', jugadorId.id)
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '50%',
        title: 'Eliminar Jugador Del Equipo',
        body: {
          objectMain: { id: jugadorId.id },
          url: this.get_urls['jugadores.delete'],
          message: '¿Estás seguro de eliminar al Jugador del Equipo?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    },
    rolJug (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Agregar Rol',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_RolForm,
            url: this.get_urls['jugadores.rol'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    async getValidatedDocuments (folio) {
      try {
        const response = await axios.get(`/api/jugador/${folio}/documentos-validados`)
        return response.data.validated_documents_count
      } catch (error) {
        console.error('Error al obtener los documentos validados:', error)
        return 0
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object', 'get_DocumentForm', 'get_InvalideForm', 'get_RolForm'])
  },
  mounted () {
    // Verificar si get_urls tiene datos correctos
    // console.log('get_urls al montar el componente:', this.get_urls)
  },
  watch: {
    model (obj) {
      this.tab = 0
    },
    get_object (val) {
      if (val) {
        this.familia = val
      }
    }
  }
}
</script>
